<template>
  <form class="CREATE-PASSWORD-FORM" @submit.prevent="submit">
    <div class="h4 text-bold m-b-1">
      Create a Password
    </div>
    <div class="m-b-4 INSTRUCTION-TEXT" >
      For a quick sign in next time,
      set a password associated with your email address:<br/>
      <span class="text-bold">{{ email }}</span>
    </div>
    <password-fields ref="passwordfields" :disabled="loading"/>
    <special-message ref="error" type="error" class="m-b-2" selenium="reset-password-error">
      Failed to create password. Please try again later.
    </special-message>
    <special-message ref="success" type="success" class="m-b-2" selenium="password-form-success">
      Successfully updated password.
    </special-message>
    <div class="text-left m-b-2">
      Password must:
      <ul class="PASSWORD-LIST">
        <li>At least 8 characters long</li>
        <li>Contain both numbers and letters</li>
      </ul>
    </div>
    <button
        :disabled="loading"
        type="submit"
        class="btn w-100 m-b-2"
        selenium="reset-password-button">
      Save Password
    </button>
    <a class="link" @click="handleDoNotCreatePassword">I don't want to create a password</a>
  </form>
</template>

<script>
import { updateMyPassword } from '@homeservices/api-kit/search/user';
import { mapGetters } from 'vuex';
import PasswordFields from '@/components/PasswordFields';
import SpecialMessage from '@/components/SpecialMessage';


export default {
  name: 'create-a-password',
  components: {
    PasswordFields,
    SpecialMessage,
  },
  props: {
    redirectTo: {
      type: [Object, String],
      default: null,
    },
    autoRedirect: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('user', ['me']),
    email () {
      return this.me.login_identifier;
    },
  },
  methods: {
    async submit () {
      this.$refs.error.hide();

      const valid = await this.$refs.passwordfields.$validate();
      if (!valid) { return; }

      try {
        this.loading = true;
        await updateMyPassword({
          password: this.$refs.passwordfields.getPassword(),
        });
        this.$refs.success.trigger();
        setTimeout(() => {
          this.redirect();
        }, 2000);
      } catch (err) {
        this.$refs.error.trigger(10000);
      } finally {
        this.loading = false;
        this.$refs.passwordfields.reset();
        this.$events.$emit(this.$events.SAVE_PASSWORD_CLICK);
      }
    },
    redirect () {
      if (this.redirectTo && this.redirectTo !== '/') {
        this.$router.push(this.redirectTo);
      } else if (this.autoRedirect) {
        const isPro = this.$store.getters['user/isPro'];
        const consumerDashboardOrHomePage = this.$route.params.showRequestSearchPage ? 'homepage' : 'consumer::dashboard';
        this.$router.push({
          name: isPro ? 'dashboard' : consumerDashboardOrHomePage,
        });
      }
    },
    handleDoNotCreatePassword () {
      this.redirect();
      this.$events.$emit(this.$events.DO_NOT_WANT_TO_CREATE_PASSWORD_CLICK);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .CREATE-PASSWORD-FORM {
    text-align: center;
    @include responsive(width, 100%, 630px);
    @include margin(6 auto);
  }
  ul.PASSWORD-LIST {
    list-style-position: inside;
    margin: 0;
    padding:2px;
    font-size: 14px;
  }
</style>
